var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import isEmail from 'validator/lib/isEmail';
import isFloat from 'validator/lib/isFloat';
import isInt from 'validator/lib/isInt';
import isStringEmpty from 'validator/lib/isEmpty';
import { isObject, isEmpty } from 'lodash';
var ONE_DIGIT_PATTERN = /[0-9]/;
var ONE_LOWERCASE_LETTER_PATTERN = /[a-z]/;
var ONE_UPPERCASE_LETTER_PATTERN = /[A-Z]/;
var LATIN_LETTERS_ONLY_PATTERN = /^[A-Za-z\s]+$/;
var PASSWORD_MIN_LENGTH = 8;
export var VALIDATION_TYPE_REQUIRED = 'validators:required';
export var VALIDATION_TYPE_VALID_PASSWORD = 'validators:validPassword';
export var VALIDATION_TYPE_EMAIL = 'validators:email';
export var VALIDATION_TYPE_MIN = 'validators:min';
export var VALIDATION_TYPE_MAX = 'validators:max';
export var VALIDATION_TYPE_FLOAT = 'validators:float';
export var VALIDATION_TYPE_LATIN_LETTERS = 'validators:latinOnly';
export function required(message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_REQUIRED; }
    return function (value) {
        var stringIsEmpty = typeof value === 'string' && isStringEmpty(value, { ignore_whitespace: true });
        var isObjectEmpty = isObject(value) && isEmpty(value);
        return ((!value || stringIsEmpty || isObjectEmpty) && {
            key: message,
            options: options
        });
    };
}
export function validPassword(message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_VALID_PASSWORD; }
    return function (value) {
        if (!value) {
            return false;
        }
        if (!ONE_DIGIT_PATTERN.test(value) ||
            !ONE_LOWERCASE_LETTER_PATTERN.test(value) ||
            !ONE_UPPERCASE_LETTER_PATTERN.test(value) ||
            value.length < PASSWORD_MIN_LENGTH) {
            return { key: message, options: options };
        }
        return false;
    };
}
export function email(message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_EMAIL; }
    return function (value) {
        if (!value) {
            return false;
        }
        return !isEmail(value) && { key: message, options: options };
    };
}
export function int(settings, message, options) {
    if (message === void 0) { message = 'validators:int'; }
    return function (value) { return !isInt(value, settings) && { key: message, options: options }; };
}
export function min(min, message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_MIN; }
    return function (value) { return value < min && { key: message, options: __assign({ min: min }, options) }; };
}
export function max(max, message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_MAX; }
    return function (value) {
        return ((value > max || value > Number.MAX_SAFE_INTEGER) && {
            key: message,
            options: __assign({ max: max }, options)
        });
    };
}
export function float(message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_FLOAT; }
    return function (value) { return !isFloat(value) && { key: message, options: options }; };
}
export function latinLettersOnly(message, options) {
    if (message === void 0) { message = VALIDATION_TYPE_LATIN_LETTERS; }
    return function (value) {
        if (!value) {
            return false;
        }
        if (!LATIN_LETTERS_ONLY_PATTERN.test(value)) {
            return { key: message, options: options };
        }
        return false;
    };
}
//# sourceMappingURL=validators.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/validators/dist/validators.js
// module id = 1618
// module chunks = 118